import request from '@/utils/http'

export function getSearch(data) {
  return request({
    url: 'exhibition.search',
    method: 'get',
    params:data,
    auth: true
  })
}

export function exhibitionPost(data) {
  return request({
    url: 'exhibition.post',
    method: 'post',
    data,
    auth: true
  })
}

export function exhibitionGet(data) {
  return request({
    url: 'exhibition.get',
    method: 'get',
    params:data,
    auth: true
  })
}

export function workGet(data) {
  return request({
    url: 'exhibition.work.get',
    method: 'get',
    params:data,
    auth: true
  })
}

export function commentGet(data) {
  return request({
    url: 'work.comment.get',
    method: 'get',
    params:data,
    auth: true
  })
}

export function commentSearch(data) {
  return request({
    url: 'comment.search',
    method: 'get',
    params:data,
    auth: true
  })
}

export function getDataSearch(data) {
  return request({
    url: 'exhibition.data.search',
    method: 'get',
    params:data,
    //auth: true
  })
}

export function submitExamine(data) {
  return request({
    url: 'examine.post',
    method: 'post',
    data,
    auth: true
  })
}

